import { ICreateAndUpdateMunicipality } from "../../../types/common.interface";
import customAxios from "../../customAxios";
import { MUNICYPULITY_CREATE } from "../../routes";

const createMunicipalityCity = async (
  formData: ICreateAndUpdateMunicipality
) => {
  try {
    return (
      await customAxios.post(MUNICYPULITY_CREATE, {
        city: formData.city?._id,
        province: formData.province?._id,
        phoneNumber: formData.phoneNumber,
        name: formData.name,
        financialGroupSchool: formData.financialGroupSchool._id,
      })
    ).data;
  } catch (error: unknown) {
    console.error(error);
    return false;
  }
};

export default createMunicipalityCity;
